<app-access-manager [namespace]="namespace">
  <div id="merchantDetails">
    <app-merchant-details [merchant]="selectedMerchant" ></app-merchant-details>
  </div>
</app-access-manager>